import React, { useEffect, useState } from 'react';
import { Navbar } from '../../components/Navbar';
import { Footer } from '../../components/Footer';
import { ImageIcon, ArrowRightIcon } from 'lucide-react';
export const DesigningThumbnailsPage = () => {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <div className="w-full bg-gray-50 dark:bg-[#0A1C1A] min-h-screen" data-id="element-4680">
      <Navbar scrolled={scrolled} data-id="element-4681" />
      <main className="pt-24 pb-20" data-id="element-4682">
        <div className="container mx-auto px-4 md:px-6" data-id="element-4683">
          <div className="max-w-4xl mx-auto" data-id="element-4684">
            {/* Header */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 md:p-12 mb-12 text-white relative overflow-hidden" data-id="element-4685">
              <div className="absolute right-0 bottom-0 opacity-10" data-id="element-4686">
                <ImageIcon className="h-64 w-64" data-id="element-4687" />
              </div>
              <div className="relative z-10" data-id="element-4688">
                <h1 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-4689">
                  Designing Thumbnails That Attract Buyers
                </h1>
                <p className="text-xl opacity-90 max-w-3xl" data-id="element-4690">
                  Learn how to create clean, eye-catching thumbnails that make
                  your product stand out and encourage users to click and
                  explore.
                </p>
              </div>
            </div>
            {/* Main content */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 md:p-10 shadow-sm mb-10" data-id="element-4691">
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4692">
                Your thumbnail is often the first thing a buyer sees. A strong
                thumbnail can grab attention instantly and encourage users to
                click on your product.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4693">
                Start by keeping your design clean and focused. Avoid clutter
                and make sure the main idea of your product is immediately
                visible. A simple and clear visual usually performs better than
                something overly complex.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4694">
                Use contrast to your advantage. Make important elements stand
                out by using contrasting colors and readable text. If your
                thumbnail includes text, keep it short and easy to read even at
                smaller sizes.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4695">
                Consistency also matters. If you plan to sell multiple products,
                try to maintain a consistent visual style across your
                thumbnails. This helps build recognition and makes your products
                look more professional as a collection.
              </p>
              <p className="text-gray-600 dark:text-[#B0C1BD] mb-6 text-lg leading-relaxed" data-id="element-4696">
                Finally, think from the buyer's perspective. Your thumbnail
                should clearly communicate what the product is and why it's
                useful. If someone can understand your product in a second or
                two, you're on the right track.
              </p>
            </div>
            {/* Related resources */}
            <div className="bg-white dark:bg-[#162825] rounded-xl p-8 shadow-sm mb-10" data-id="element-4697">
              <h2 className="text-xl font-bold text-gray-800 dark:text-[#F8FAF9] mb-6" data-id="element-4698">
                Related Resources
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-4699">
                <a href="/learn/professional-look" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4700">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4701">
                    Creating a Professional Look for Your Product
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4702">
                    Use layout, typography, and visual consistency to build
                    trust and perceived value.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4703">
                    <span data-id="element-4704">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4705" />
                  </div>
                </a>
                <a href="/learn/product-descriptions" className="group block bg-gray-50 dark:bg-[#1A3330] rounded-lg p-5 transition-all hover:shadow-md" data-id="element-4706">
                  <h3 className="font-semibold text-gray-800 dark:text-[#F8FAF9] mb-2 group-hover:text-[#2DB489] dark:group-hover:text-[#4ED1A0] transition-colors" data-id="element-4707">
                    Writing Product Listings That Convert
                  </h3>
                  <p className="text-sm text-gray-600 dark:text-[#B0C1BD] mb-3" data-id="element-4708">
                    Create compelling product titles and descriptions that
                    attract buyers.
                  </p>
                  <div className="flex items-center text-[#2DB489] dark:text-[#4ED1A0] text-sm font-medium" data-id="element-4709">
                    <span data-id="element-4710">Read more</span>
                    <ArrowRightIcon className="ml-1 h-4 w-4 transform group-hover:translate-x-1 transition-transform" data-id="element-4711" />
                  </div>
                </a>
              </div>
            </div>
            {/* CTA */}
            <div className="bg-gradient-to-r from-[#0D3C45] to-[#2DB489] dark:from-[#2DB489] dark:to-[#4ED1A0] rounded-xl p-8 text-white text-center" data-id="element-4712">
              <h2 className="text-2xl font-bold mb-4" data-id="element-4713">
                Ready to design better thumbnails?
              </h2>
              <p className="text-lg opacity-90 mb-6 max-w-2xl mx-auto" data-id="element-4714">
                Apply these tips and make your products stand out in the
                marketplace.
              </p>
              <a href="/sell-product" className="inline-block bg-white text-[#0D3C45] px-6 py-3 rounded-lg font-medium hover:bg-opacity-90 transition-all" data-id="element-4715">
                Start Selling
              </a>
            </div>
          </div>
        </div>
      </main>
      <Footer data-id="element-4716" />
    </div>;
};